import { render, staticRenderFns } from "./ModalConsignmentSettingsTable.vue?vue&type=template&id=23cb623a&"
import script from "./ModalConsignmentSettingsTable.vue?vue&type=script&lang=js&"
export * from "./ModalConsignmentSettingsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports